<template>
    <div class="page">
        <div class="header" :style="{ background: $configs.headerBg }">
            <div class="center" :style="{ background: $configs.headerBg }">
                <div
                    class="logo_rectangle"
                >
                    <img :src="$configs.logo" alt="" />
                </div>
                <div class="WarrantyCheck" :style="{ color: $configs.headerColor }">
                    Warranty Check
                </div>
            </div>
        </div>

        <div class="center" >
            <div class="searchBox piece">
                <p >
                    Por favor introduzca el número IMEI para la autentificación
                </p>
                <div class="inputBox">
                    <input
                        type="text"
                        class="searchInput"
                        :placeholder="$configs.search_placeholder"
                        v-model="imei"
                    />
                </div>
                <div class="butBox">
                    <button
                        class="searchBut"
                        :style="{ background: $configs.site }"
                        @click="search"
                    >
                        Verifica
                    </button>
                </div>

                <p class="resultText" v-if="status == 2">Sin garantía</p>
                <p class="resultText" v-if="status == 1">En garantía</p>
                <p class="resultText" v-if="status == -1">No tiene el IMEI en el sistema</p>
            </div>
            <!-- 有结果 -->
            <div
                class="IMEIInfo piece"
                v-if="(status >0)"
            >
                <p class="no">
                    Tu número de IMEI : <span>{{ data.imei }}</span>
                </p>
                <p class="line">
                    Nombre del producto :
                    <span>{{ data.itemName }}</span>
                </p>
               
            </div>
            <p class="title" :style="{ color: $configs.site }">Servicio Tecnicos</p>
            <!-- 在保 -->
            <div class="underWarranty piece">
                <ul>
                    <li>
                        <p class="title">La Paz-</p>
                        <p class="text">
                            Av. Buenos Aires c/Tumusla Ed. 14 de Septiembre.
                        </p>
                        <p class="phoneNo" :style="{ color: $configs.site }">
                            Teléfono: 591 60605742
                        </p>
                    </li>
                    <li>
                        <p class="title">El Alto-</p>
                        <p class="text">
                            Av. Franco Valle y Calle 1(Ceja El Alto).
                        </p>
                        <p class="phoneNo" :style="{ color: $configs.site }">
                            Teléfono: 591 78877112
                        </p>
                    </li>
                    <li>
                        <p class="title">Santa Cruz-</p>
                        <p class="text">
                            Calle Cañada Strongest # 351, atrás de IMCRUZ segundo anillo.
                        </p>
                        <p class="phoneNo" :style="{ color: $configs.site }">
                            Teléfono: 591 78018050
                        </p>
                    </li>
                    <li>
                        <p class="title">Cochabamba-</p>
                        <p class="text">
                            Ladislao Cabrera # 541 entre San Martin y Lanza.
                        </p>
                        <p class="phoneNo" :style="{ color: $configs.site }">
                            Teléfono: 591 74353337
                        </p>
                    </li>
                    <li>
                        <p class="title">Lima-</p>
                        <p class="text">Jr.Cuzco,Mesa Redonda.</p>
                        <p class="phoneNo" :style="{ color: $configs.site }">
                            Teléfono: 51 941 633 817
                        </p>
                    </li>
                    <li>
                        <p class="title">Iquique-</p>
                        <p class="text">
                            Manzana 3 Galpon 20A, Zona Franca, Iquique, Chile.
                        </p>
                    </li>
                </ul>
            </div>
            <div >
                <!-- 过保 -->
                <div v-if="(isExist == 'false') | (status == '2')">
                    <div class="outWarranty piece">
                        <ul>
                            <li>
                                <p class="title">Collection Point 1</p>
                                <p class="text" :style="{ color: $configs.site }">
                                    Raya Care ABA
                                </p>
                                <p>Address: 31 Str. Micheals road Aba.</p>
                                <p class="phoneNo">Tel.: 70072922273</p>
                            </li>
                            <li>
                                <p class="title">Collection Point 2</p>
                                <p class="text" :style="{ color: $configs.site }">
                                    Raya Care ILLORIN
                                </p>
                                <p>
                                    Address: 199, Ibrahim Taiwo road, promo plaza ,
                                    Illorin
                                </p>
                                <p class="phoneNo">Tel.: 70072922273</p>
                            </li>
                            <li>
                                <p class="title">Collection Point 3</p>
                                <p class="text" :style="{ color: $configs.site }">
                                    Raya Care Warri
                                </p>
                                <p>Address: Shop H29, Block , Robinson plaza , Warri</p>
                                <p class="phoneNo">Tel.: 70072922273</p>
                            </li>
                            <li>
                                <p class="title">Collection Point 4</p>
                                <p class="text" :style="{ color: $configs.site }">
                                    Raya Care Kano
                                </p>
                                <p>Address: 18D,civic center road,kano</p>
                                <p class="phoneNo">Tel.: 70072922273</p>
                            </li>
                        </ul>
                    </div>
                    <div class="outWarranty piece">
                        <ul>
                            <li>
                                <p class="title">Collection Point 1</p>
                                <p class="text" :style="{ color: $configs.site }">
                                    Raya Care ABUJA
                                </p>
                                <p>
                                    Address: Garkida House , Alexandria Crescent Behind
                                    Banex Plaza, Wuse 2 , Abuja
                                </p>
                                <p class="phoneNo">Tel.: 70072922273</p>
                            </li>
                            <li>
                                <p class="title">Collection Point 2</p>
                                <p class="text" :style="{ color: $configs.site }">
                                    Raya Care ASABA
                                </p>
                                <p>
                                    Address: 23 ibusa road, beside winners chapel, Asaba
                                </p>
                                <p class="phoneNo">Tel.: 70072922273</p>
                            </li>
                            <li>
                                <p class="title">Collection Point 3</p>
                                <p class="text" :style="{ color: $configs.site }">
                                    Raya Care Ibadan
                                </p>
                                <p>
                                    Address: Golden age plaza, Plot 125, magazine road,
                                    Jericho, Ibadan
                                </p>
                                <p class="phoneNo">Tel.: 70072922273</p>
                            </li>
                            <li>
                                <p class="title">Collection Point 4</p>
                                <p class="text" :style="{ color: $configs.site }">
                                    Raya Care IKEJA
                                </p>
                                <p>
                                    Address: 18 Str. kodesho opposite computer village
                                    gate, ikeja , Lagos.
                                </p>
                                <p class="phoneNo">Tel.: 70072922273</p>
                            </li>
                            <li>
                                <p class="title">Collection Point 5</p>
                                <p class="text" :style="{ color: $configs.site }">
                                    Raya care PHC
                                </p>
                                <p>
                                    Address: 30 Str. Okporo Road, by former Mr Biggs, Port
                                    Harcourt , River State
                                </p>
                                <p class="phoneNo">Tel.: 70072922273</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
    name: "Index",
    data() {
        return {
            imei: "",
            data: {},
            isExist: "",
            status: "",
            site: "",
            logo: "",
            headerBg: "",
            headerColor: "",
        };
    },
    mounted() {
        this.site = this.$configs.site;
        this.logo = this.$configs.logo;
        this.headerBg = this.$configs.headerBg;
        this.headerColor = this.$configs.headerColor;
    },
    methods: {
        ...mapActions(["getByImei"]),

        search() {
            this.getByImeiFun();
        },
        // 查询串码
        async getByImeiFun() {
            const response = await this.getByImei({
                imei: this.imei,
            });

            if (response.success) {
                if ((response.data != "") & (response.data != null)) {
                    this.data = response.data;
                    this.status = response.data.status;
                  
                } else {
                    this.status = -1;
                    this.data = {};
                }
            } else {
                // this.$notify.error({
                //     title: "错误",
                //     message: response.msg,
                // });
                alert("错误:" + response.msg);
            }
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
ul
    list-style-type: none;
    margin: 0;
    padding: 0;

.resultText
    font-weight: bold;

.page
    background-color: #f2f2f2;
    margin: 0;
    padding: 0;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    padding-bottom: 20px;
    min-height 100%
    height auto
    width 100%

    .header
        height: 60px;
        margin-bottom: 20px;

        .center
            width: 1200px;
            margin: 0 auto;
            display: flex;
            justify-content: flex-start;

            .logo_rectangle
                height: 60px;
                width: 215px;

                img
                    height: 100%;
                    width: 100%;
            .logo_square
                height: 60px;
                width: 60px;

                img
                    height: 100%;
                    width: 100%;

            .WarrantyCheck
                height: 60px;
                line-height: 60px;
                margin-left: 40px;
                font-size: 20px;

    .center
        width: 1200px;
        background-color: #f2f2f2;
        margin: 0 auto;
        .adImg
            width: 1200px;
            margin: 0 auto;
            img
                height: 100%;
                width: 100%;
        .title
            height: 50px;
            line-height: 50px;
            background-color: #f2f2f2;
            font-size: 30px;
            margin: 20px 0;

    .piece
        background-color: #ffffff;
        padding: 40px 0;

    .searchBox
        margin-bottom: 20px;

        p
            text-align: center;
            font-size: 28px;
            height: 70px;
            line-height: 70px;

        .inputBox
            width: 700px;
            margin: 0 auto;

            .searchInput
                border: 1px solid #828181;
                height: 70px;
                line-height: 70px;
                width: 700px;
                padding-left: 10px;

            input::-webkit-input-placeholder
                color: #828181;
                font-size: 20px;
                padding-left: 10px;

        .butBox
            width: 200px;
            margin: 0 auto;

            .searchBut
                width: 200px;
                height: 65px;
                font-size: 20px;
                color: #fff;
                border: none;
                margin-top: 40px;
                cursor: pointer;

    .IMEIInfo
        padding-left: 200px;

        .no
            font-size: 24px;
            height: 50px;
            line-height: 50px;

    .underWarranty
        li
            margin-left: 200px;

            .title
                font-size: 24px;
                background-color: #ffffff;
                color: #222;
                height: 20px;
                line-height: 20px;
                margin-bottom: 10px;

    .outWarranty
        margin-top: 20px;

        ul
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin: 0 200px;

            li
                width: 360px;
                display: inline-block;
                margin: 20px 0;
                height: 180px;

                p
                    word-wrap: break-word;
                    word-break: break-all;
                    overflow: hidden;

                .title
                    font-size: 24px;
                    background-color: #ffffff;
                    color: #222;
                    height: 20px;
                    line-height: 20px;
                    margin-bottom: 10px;

                .phoneNo
                    font-weight: bold;
</style>



// WEBPACK FOOTER //
// src/views/pc/chile-infinix.vue